export default "__VITE_ASSET__0b97795f__"